<template>
  <div>
    <v-container fluid grid-list-md class="padding_10">
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12 lg12 md12 style="display: flex; flex-wrap: wrap; align-items: center;">
          <v-flex xs6 md6 lg2>
            <v-btn style="width: 150px; max-width: 150px; height: 50px;" color="primary" @click="addImport">Import Schedule</v-btn>
          </v-flex>

          <v-flex xs6 md6 lg2>
            <v-btn style="width: 150px; max-width: 150px; height: 50px;" color="success" @click="approveImportDialog()">Confirm
              Imports</v-btn>
          </v-flex>

          <v-flex xs6 md6 lg2 style="margin-right: 20px;">
            <v-btn style="width: 170px; max-width: 170px; height: 50px;" color="primary"
                   @click="addUpdateImportDialog = true">Add/Update Schedule</v-btn>
          </v-flex>

          <v-flex xs12 md6 lg2 style="margin-right: 30px;">
            <v-btn style="width: 180px; max-width: 180px; height: 50px;" color="primary" @click="downloadDialog = true">
              Download Import<br>Sample</v-btn>
          </v-flex>

          <v-flex xs12 md6 lg3>
            <v-btn style="width: 200px; max-width: 200px; height: 50px;" larger
                   color="primary"
                   @click="downloadCompleteTrainSchedule = true">
              <span style="text-align: center;">Download Complete<br> Train Schedule</span></v-btn>
          </v-flex>
          <!--          type="a" target="_blank" :href="getBackendPublicURL('/Train-Schedule-Import-Sample.xlsx')"-->



        </v-flex>
        <v-flex xs12>
          <v-data-table
              no-results-text="Loading... Please wait"
              :headers="headers"
              :items="import_masters"
              item-key="id"
              :loading="loading.import_masters"
              :total-items="total_items"
              :rows-per-page-items="[10, 20, 50, 100]"
          >
            <template v-slot:headers="props">
              <tr>
                <th
                    v-for="header in props.headers"
                    :key="header.text"
                >
                  {{ header.text }}
                  <v-icon small v-if="header.sortable !== false"
                  >arrow_upward
                  </v-icon
                  >
                </th>
                <th>
                  Action
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td>
                {{ props.item.line_name }}
              </td>
              <td>
                {{ props.item.direction_name }}
              </td>
              <td>
                <import-status :status="props.item.status"></import-status>
              </td>
              <td>
                <a v-if="props.item.file_path" :href="createFileLink(props.item.file_path)" target="_blank">
                  File
                </a>
                <span v-else>-</span>
              </td>
              <td>
                <a v-if="props.item.status !== 'confirmed' && props.item.error_file_path"
                   :href="createFileLink(props.item.error_file_path)" target="_blank">
                  Error File
                </a>
                <span v-else>-</span>
              </td>
              <td>
                {{ props.item.updated_at | appDateTimeFormat }}
              </td>
              <td>
                <v-tooltip bottom v-if="props.item.status === 'pending'">
                  <template v-slot:activator="{ on }">
                    <v-btn icon flat color="primary" @click="approveImportDialog(props.item.id)" v-on="on">
                      <v-icon>done</v-icon>
                    </v-btn>
                  </template>
                  <span>Confirm</span>
                </v-tooltip>
                <!--                <v-tooltip bottom v-if="props.item.status === 'error'">-->
                <!--                  <template v-slot:activator="{ on }">-->
                <!--                    <v-btn icon flat color="primary" @click="updateImport(props.item)" v-on="on">-->
                <!--                      <v-icon>cached</v-icon>-->
                <!--                    </v-btn>-->
                <!--                  </template>-->
                <!--                  <span>Re-upload</span>-->
                <!--                </v-tooltip>-->
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
      <v-snackbar
          :timeout="snack_bar.timeout"
          :color="snack_bar.color"
          :top="snack_bar.top"
          :bottom="snack_bar.bottom"
          :left="snack_bar.left"
          :right="snack_bar.right"
          v-model="snack_bar.show"
      >
        {{ snack_bar.message }}
        <v-btn dark flat @click.native="snack_bar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
    <v-dialog v-model="approveImportDialogShow" max-width="1000">
      <v-card>
        <v-card-title class="headline justify-space-between pb-0">
          Approve Imports
          <v-btn icon @click="approveImportDialogShow = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-data-table
                  :headers="headers"
                  :items="pendingImports"
                  select-all
                  item-key="id"
              >
                <template v-slot:headers="props">
                  <tr>
                    <th>
                    </th>
                    <th
                        v-for="header in props.headers"
                        :key="header.text"
                    >
                      <v-icon small>arrow_upward</v-icon>
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template v-slot:items="props">
                  <tr>
                    <td>
                      <v-checkbox
                          v-model="approveMasterIds"
                          :value="props.item.id"
                          primary
                          hide-details
                      ></v-checkbox>
                    </td>
                    <td>
                      {{ props.item.line_name }}
                    </td>
                    <td>
                      {{ props.item.direction_name }}
                    </td>
                    <td>
                      <import-status :status="props.item.status"></import-status>
                    </td>
                    <td>
                      <a v-if="props.item.file_path" :href="createFileLink(props.item.file_path)" target="_blank">
                        File
                      </a>
                      <span v-else>-</span>
                    </td>
                    <td>
                      <a v-if="props.item.status !== 'confirmed' && props.item.error_file_path"
                         :href="createFileLink(props.item.error_file_path)" target="_blank">
                        Error File
                      </a>
                      <span v-else>-</span>
                    </td>
                    <td>
                      {{ props.item.updated_at | appDateTimeFormat }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-end>
            <v-btn type="submit"
                   class="mr-3 mb-3"
                   :disabled="!valid || loading.submit"
                   color="primary"
                   @click="approveImport"
                   :loading="loading.submit">
              Approve
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="headingErrorsShow" max-width="600">
      <v-card>
        <v-card-title class="headline justify-space-between pb-0">
          Station Code Error
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              {{ headingErrors }}
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="storeDialog" max-width="600">
      <v-card>
        <v-card-title class="headline justify-space-between pb-0">
          <span v-if="masterImportId">Master Import Update</span>
          <span v-else>Master Import Add</span>
          <v-btn icon @click="storeDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-form
            data-vv-scope="saveImport"
            id="saveImport"
            ref="saveImport"
            v-model="valid"
            lazy-validation
            @submit.prevent="validateBeforeSubmit('saveImport')">
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-select
                    solo flat
                    v-model="line_id"
                    :loading="loading.lines"
                    :items="lines"
                    item-text="name"
                    item-value="id"
                    label="Line"
                    :error-messages="errors.collect('saveImport.line_id')"
                    v-validate="'required'"
                ></v-select>
              </v-flex>
              <v-flex xs12 md6>
                <v-select
                    solo flat
                    v-model="direction_id"
                    :loading="loading.directions"
                    :items="directions"
                    item-text="name"
                    item-value="id"
                    label="Direction"
                    :error-messages="errors.collect('saveImport.direction_id')"
                    v-validate="'required'"
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <input type="file" name="master_data_file" accept="*/*" id="master_data_file"
                />
                <!--                v-validate="'required|mimes:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"-->
              </v-flex>
              <v-flex xs12>
                <span class="red--text" v-if="errors.collect('saveImport.master_data_file').length">{{
                    errors.collect('saveImport.master_data_file')[0]
                  }}</span>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-end>
              <v-btn type="submit"
                     class="mr-3 mb-3"
                     :disabled="!valid || loading.submit"
                     color="primary"
                     :loading="loading.submit">Submit
              </v-btn>
            </v-layout>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>


    <!--    DOWNLOAD SAMPLE FILE-->
    <v-dialog v-model="downloadDialog" max-width="600">
      <v-card>
        <v-card-title class="headline justify-space-between pb-0">
          <span v-if="masterImportId">Download Master Import File</span>
          <span v-else>Download Master Import Sample</span>
          <v-btn icon @click="downloadDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-form ref="form"
                v-model="valid"
                lazy-validation
                data-vv-scope="downloadImport"
                @submit.prevent="validateBeforeSubmit('downloadImport')">
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-select
                    solo flat
                    v-model="downloadLine"
                    :loading="loading.lines"
                    :items="lines"
                    item-text="name"
                    item-value="id"
                    label="Line"
                    :error-messages="errors.collect('downloadImport.line_id')"
                    v-validate="'required'"
                ></v-select>
              </v-flex>
              <v-flex xs12 md6>
                <v-select
                    solo flat
                    v-model="downloadDirection"
                    :loading="loading.directions"
                    :items="directions"
                    item-text="name"
                    item-value="id"
                    label="Direction"
                    :error-messages="errors.collect('downloadImport.direction_id')"
                    v-validate="'required'"
                ></v-select>
              </v-flex>
              <v-flex xs12 md6 v-if="downloadLine == 3">
                <v-select
                    solo flat
                    v-model="downloadHarbourRoute"
                    :items="harbourRoutes"
                    item-text="name"
                    item-value="id"
                    label="Route"
                ></v-select>
              </v-flex>

              <v-flex xs12 md12><br/></v-flex>
              <br/>
              <div v-if="downloadLine == 1 && downloadDirection == 1">
                <a target="_blank"
                   :href="getBackendPublicURL('Train_Schedules/CENTRAL UP(KASARA - KHOPOLI - KALYAN - CSMT).csv')">Click
                  here to Download Sample File</a>
              </div>
              <div v-else-if="downloadLine == 1 && downloadDirection == 2">
                <a target="_blank"
                   :href="getBackendPublicURL('Train_Schedules/CENTRAL DOWN(CSMT - KALYAN - KHOPOLI - KASARA).csv')">Click
                  here to Download Sample File</a>
              </div>

              <div v-else-if="downloadLine == 2 && downloadDirection == 1">
                <a target="_blank" :href="getBackendPublicURL('Train_Schedules/WESTERN UP(DRD - CCG).csv')">Click here
                  to Download Sample File</a>
              </div>
              <div v-else-if="downloadLine == 2 && downloadDirection == 2">
                <a target="_blank" :href="getBackendPublicURL('Train_Schedules/Western DOWN (CCG - DRD).csv')">Click
                  here to Download Sample File</a>
              </div>

              <!-- PNVL - CSMT Route -->
              <div v-else-if="downloadLine == 3 && downloadDirection == 1 && downloadHarbourRoute == 'PNVL_CSMT'">
                <a target="_blank" :href="getBackendPublicURL('Train_Schedules/Harbour UP (PNVL - CSMT).csv')">Click
                  here to Download Sample File</a>
              </div>
              <div v-else-if="downloadLine == 3 && downloadDirection == 2 && downloadHarbourRoute == 'PNVL_CSMT'">
                <a target="_blank" :href="getBackendPublicURL('Train_Schedules/Harbour DOWN (CSMT - PNVL).csv')">Click
                  here to Download Sample File</a>
              </div>

              <!-- GMN - CSMT Route -->
              <div v-else-if="downloadLine == 3 && downloadDirection == 1 && downloadHarbourRoute == 'CSMT_GMN'">
                <a target="_blank" :href="getBackendPublicURL('Train_Schedules/Harbour UP (GMN - CSMT).csv')">Click
                  here to Download Sample File</a>
              </div>
              <div v-else-if="downloadLine == 3 && downloadDirection == 2 && downloadHarbourRoute == 'CSMT_GMN'">
                <a target="_blank" :href="getBackendPublicURL('Train_Schedules/Harbour DOWN (CSMT - GMN).csv')">Click
                  here to Download Sample File</a>
              </div>

              <!-- GMN - PNVL Route -->
              <div v-else-if="downloadLine == 3 && downloadDirection == 1 && downloadHarbourRoute == 'PNVL_GMN'">
                <a target="_blank" :href="getBackendPublicURL('Train_Schedules/Harbour UP (PNVL - GMN).csv')">Click
                  here to Download Sample File</a>
              </div>
              <div v-else-if="downloadLine == 3 && downloadDirection == 2 && downloadHarbourRoute == 'PNVL_GMN'">
                <a target="_blank" :href="getBackendPublicURL('Train_Schedules/Harbour DOWN (GMN - PNVL).csv')">Click
                  here to Download Sample File</a>
              </div>

              <div v-else-if="downloadLine == 4 && downloadDirection == 1">
                <a target="_blank" :href="getBackendPublicURL('Train_Schedules/Trans Harbour UP(PNVL - TNA).csv')">Click
                  here to Download Sample File</a>
              </div>
              <div v-else-if="downloadLine == 4 && downloadDirection == 2">
                <a target="_blank" :href="getBackendPublicURL('Train_Schedules/Trans Harbour DOWN (TNA -PNVL).csv')">Click
                  here to Download Sample File</a>
              </div>

              <div v-else-if="downloadLine == 5 && downloadDirection == 1">
                <a target="_blank" :href="getBackendPublicURL('Train_Schedules/URAN UP (URAN - NEU).csv')">Click here
                  to Download Sample File</a>
              </div>
              <div v-else-if="downloadLine == 5 && downloadDirection == 2">
                <a target="_blank" :href="getBackendPublicURL('Train_Schedules/URAN DOWN (NEU - URAN).csv')">Click here
                  to Download Sample File</a>
              </div>

              <div v-else-if="downloadLine == 6 && downloadDirection == 1">
                <a target="_blank" :href="getBackendPublicURL('Train_Schedules/Panvel-vasai UP (ROHA - DRD).csv')">Click
                  here to Download Sample File</a>
              </div>
              <div v-else-if="downloadLine == 6 && downloadDirection == 2">
                <a target="_blank" :href="getBackendPublicURL('Train_Schedules/Panvel-vasai DOWN (DRD - ROHA).csv')">Click
                  here to Download Sample File</a>
              </div>

              <div v-else-if="downloadLine == 7 && downloadDirection == 1">
                <a target="_blank" :href="getBackendPublicURL('Train_Schedules/Neral - Matheran UP (MAE - NRL).csv')">Click
                  here to Download Sample File</a>
              </div>
              <div v-else-if="downloadLine == 7 && downloadDirection == 2">
                <a target="_blank" :href="getBackendPublicURL('Train_Schedules/Neral - Matheran DOWN(NRL -MAE).csv')">Click
                  here to Download Sample File</a>
              </div>
              <v-flex xs12 md12 sm12 lg12>

              </v-flex>
              <v-flex xs12>
                <span class="red--text" v-if="errors.collect('downloadImport.master_data_file').length">{{
                    errors.collect('downloadImport.master_data_file')[0]
                  }}</span>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>


    <!--    Add Update Schedule FILE-->
    <v-dialog v-model="addUpdateImportDialog" max-width="600">
      <v-card>
        <v-card-title class="headline justify-space-between pb-0">
          <v-flex xs12 md12 lg12 style="display: flex;justify-content: space-between;">
            <span>Add/Update Train Schedule</span>
            <v-btn icon @click="addUpdateImportDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-card-title>
        <v-form ref="addUpdateTrainScheduleImport"
                id="addUpdateTrainScheduleImport"
                v-model="valid"
                lazy-validation
                data-vv-scope="addUpdateTrainScheduleImport"
                @submit.prevent="validateBeforeSubmit('addUpdateTrainScheduleImport')">
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-autocomplete
                    solo flat
                    v-model="downloadLine"
                    :loading="loading.lines"
                    :items="lines"
                    item-text="name"
                    item-value="id"
                    label="Line"
                    :error-messages="errors.collect('addUpdateTrainScheduleImport.line_id')"
                    v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete
                    solo flat
                    v-model="downloadDirection"
                    :loading="loading.directions"
                    :items="directions"
                    item-text="name"
                    item-value="id"
                    label="Direction"
                    :error-messages="errors.collect('addUpdateTrainScheduleImport.direction_id')"
                    v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                    :value="selectedDateTime"
                    label="Date & Time"
                    readonly
                    solo flat
                    prepend-inner-icon="event"
                    @click="openFlatpickr"
                    ref="dateTimeField"
                ></v-text-field>
                <flat-pickr
                    v-model="selectedDateTime"
                    :config="flatpickrConfig"
                    ref="flatpickrRef"
                    style="display: none;"
                    class="mt-3 ml-2"
                ></flat-pickr>
              </v-flex>
              <v-flex xs12 md6>
                <input type="file" name="master_data_file" ref="fileupload" accept="*/*" id="master_data_file"/>
                <!-- v-validate="'required|mimes:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"-->
              </v-flex>

              <v-flex xs12>
                <span class="red--text" v-if="errors.collect('addUpdateTrainScheduleImport.master_data_file').length">{{
                    errors.collect('addUpdateTrainScheduleImport.master_data_file')[0]
                  }}</span>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <span style="color: red">**To Add/Update Train Schedule with Limited Records at time.</span>
            <v-layout justify-end>
              <v-btn type="submit"
                     class="mr-3 mb-3"
                     :disabled="!valid || loading.submit"
                     color="primary"
                     :loading="loading.submit">Submit
              </v-btn>
            </v-layout>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!--      download complete schedule dialog-->
    <v-dialog v-model="downloadCompleteTrainSchedule" max-width="600">
      <v-card>
        <v-card-title class="headline justify-space-between pb-0">
          <v-flex xs12 md12 lg12 style="display: flex;justify-content: space-between;">
            <span>Export Train Schedule</span>
            <v-btn icon @click="downloadCompleteTrainSchedule = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-card-title>
        <v-form ref="exportCompleteTrainSchedule"
                id="exportCompleteTrainSchedule"
                v-model="valid"
                lazy-validation
                data-vv-scope="exportCompleteTrainSchedule"
                @submit.prevent="validateBeforeSubmit('exportCompleteTrainSchedule')">
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-select
                    solo flat
                    v-model="completeScheduleDownloadLine"
                    :loading="loading.lines"
                    :items="lines"
                    item-text="name"
                    item-value="id"
                    label="Line"
                    :error-messages="errors.collect('exportCompleteTrainSchedule.line_id')"
                    v-validate="'required'"
                ></v-select>
              </v-flex>
              <v-flex xs12 md6>
                <v-select
                    solo flat
                    v-model="completeScheduleDownloadDirection"
                    :loading="loading.directions"
                    :items="directions"
                    item-text="name"
                    item-value="id"
                    label="Direction"
                    :error-messages="errors.collect('exportCompleteTrainSchedule.direction_id')"
                    v-validate="'required'"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-end>
              <v-btn type="submit"
                     class="mr-3 mb-3"
                     :disabled="(completeScheduleDownloadDirection == '' || completeScheduleDownloadLine == '')"
                     color="primary"
                     :loading="loading.submit">Export
              </v-btn>
            </v-layout>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ImportStatus from "./ImportStatus";
import moment from "moment";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  components: {
    ImportStatus,
    flatPickr
  },
  computed: {
    pendingImports() {
      return this.import_masters.filter((item) => item.status === 'pending')
    },
    dateTimeDisplay() {
    if (!this.selectedDate) return '';
    const time = this.selectedTime ? this.selectedTime.slice(0, 5) : '';
    return time ? `${this.selectedDate} ${time}` : this.selectedDate;
  }
  },
  name: "Index",
  mounted() {
    this.getData()
    this.getLinesList()
    this.getDirectionList()
  },
  methods: {
    addImport() {
      this.masterImportId = null
      this.storeDialog = true
    },
    validateBeforeSubmit: function (scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this[scope]();
        }
      });
    },
    updateImport(master_record) {
      this.masterImportId = master_record.id
      this.direction_id = master_record.direction_id
      this.line_id = master_record.line_id
      this.storeDialog = true
    },
    approveImportDialog(id = null) {
      this.approveMasterIds = id ? [id] : []
      this.approveImportDialogShow = true
    },
    approveImport() {
      this.startLoading()
      if (this.approveMasterIds.length) {
        axios.post(`${process.env.VUE_APP_API_URL}/api/v1/train-master/import/approve`, {ids: this.approveMasterIds}, {headers: this.$headers})
            .then((response) => {
              this.storeDialog = false
              if (response.data.status == 1) {
                this.approveImportDialogShow = false
                this.getData()
              }
            })
            .finally(() => {
              this.loading.submit = false
              this.stopLoading()
            })
      } else {
        this.snack_bar.message = 'Select At least 1 item'
        this.snack_bar.show = true
      }
    },
    saveImport() {
      this.startLoading()
      this.loading.submit = true
      // let formData = new FormData(this.$refs.form.$el)
      var myForm = $('#saveImport')[0];
      let formData = new FormData(myForm);
      formData.append('line_id', this.line_id)
      formData.append('direction_id', this.direction_id)

      let url;
      if (this.masterImportId) {
        url = '/'
      } else {
        url = ''
      }
      // ${this.masterImportId ? '/' + this.masterImportId : ''}
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/train-master/import/` + url, formData, {headers: this.$headers})
          .then((response) => {
            this.storeDialog = false
            if (response.data.status == 1)
              this.getData()
            else {
              this.headingErrors = response.data.message
              this.headingErrorsShow = true
              this.$refs.form.reset();
              document.getElementById("master_data_file").value = "";
            }
          })
          .finally(() => {
            this.loading.submit = false
            this.stopLoading()
          })
    },
    getLinesList() {
      this.loading.lines = true
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/lines`, {headers: this.$headers})
          .then((response) => {
            if (response.data.status == 1) {
              this.lines = response.data.data
            }
          })
          .finally(() => {
            this.loading.lines = false
          })
    },
    getDirectionList() {
      this.loading.directions = true
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/directions`, {headers: this.$headers})
          .then((response) => {
            if (response.data.status == 1) {
              this.directions = response.data.data
            }
          })
          .finally(() => {
            this.loading.directions = false
          })
    },
    getData() {
      this.loading.import_masters = true;
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/train-master`, {headers: this.$headers})
          .then((response) => {
            if (response.data.status == 1) {
              this.import_masters = response.data.data;
              this.total_items = response.data.total;
            }
          })
          .catch((error) => {
            console.log(error);
            this.snack_bar.message = "Error Occurred";
            this.snack_bar.show;
          })
          .finally(() => {
            {
              this.loading.import_masters = false;
            }
          });
    },
    getBackendPublicURL(filePath) {
      return `${process.env.VUE_APP_API_URL}/${filePath}`
    },
    addUpdateTrainScheduleImport() {
      this.startLoading()
      this.loading.submit = true
      var myForm = $('#addUpdateTrainScheduleImport')[0];
      let formData = new FormData(myForm);
      formData.append('line_id', this.downloadLine)
      formData.append('direction_id', this.downloadDirection)
      if (this.selectedDateTime) {
        const [date, time] = this.selectedDateTime.split(' ');
        formData.append('date', date)
        formData.append('time', time ? time + ':00' : '')
        formData.append('updated_at', time ? `${date} ${time}:00` : date)

      }

      let url;
      if (this.masterImportId) {
        url = '/'
      } else {
        url = ''
      }
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/train-master/importDataToUpdate`, formData, {headers: this.$headers})
          .then((response) => {
            this.storeDialog = false
            if (response.data.status == 1) {
              // this.getData()
              const url = this.getBackendPublicURL(response.data.data);
              this.addUpdateImportDialog = false;

              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', response.data.data);
              document.body.appendChild(link);
              link.click();

              this.downloadLine = '';
              this.downloadDirection = '';
              this.$refs.addUpdateTrainScheduleImport.reset();
              this.file = '';
              this.$refs.fileupload.value = null;
            } else {
              this.headingErrors = response.data.message
              this.headingErrorsShow = true
              this.$refs.form.reset();
              document.getElementById("master_data_file").value = "";
            }
          }).catch((error) => {
        console.log(error);
        this.snack_bar.message = "Error Occurred";
        this.snack_bar.show;
      })
          .finally(() => {
            this.loading.submit = false
            this.stopLoading()
          })
    },
    download1(Line, Direction, data) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      var directionName;
      if(Direction == 1){
        directionName = "UP";
      }else{
        directionName = "Down";
      }
      link.setAttribute('download',
          'Train_Schedule_Line_' + Line+ "_direction_"+ directionName +"_" + moment().format('YYYY-MM-DD')
          + '.csv');
      document.body.appendChild(link);
      link.click();
    },
    exportCompleteTrainSchedule() {
      this.startLoading();
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/export-line-wise-train-schedule`,
          {line_id: this.completeScheduleDownloadLine, direction_id: this.completeScheduleDownloadDirection},
          {headers: this.$headers, responseType: 'blob'})
          .then((response) => {
            this.download1(this.completeScheduleDownloadLine, this.completeScheduleDownloadDirection, response.data);
            this.downloadCompleteTrainSchedule = false;
            this.completeScheduleDownloadDirection = '';
            this.completeScheduleDownloadLine = '';
            this.downloadCompleteTrainSchedule = false;
          }).catch((error) => {
        console.warn(error);
        this.snackbar.display = true;
        this.snackbar.message = "Something Went Wrong";
      }).finally(() => {
        this.stopLoading()
      })
    },
    onDateChange() {
      const today = this.minDate;
      if (this.selectedDate === today) {
        const now = new Date();
        now.setMinutes(now.getMinutes() + 2);
        this.selectedTime = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;
      } else {
        this.selectedTime = '03:00'; // HH:mm only, no seconds
      }
    },
    onTimeChange(value) {
      if (value) {
        this.selectedTime = value.toString().slice(0, 5);
      }
    },
    closeDateTimePicker() {
      this.filterDateMenu = false;
    },
    allowedHours(hour) {
      if (this.selectedDate !== this.minDate) {
        return true;
      }
      const now = new Date();
      now.setMinutes(now.getMinutes() + 2);
      return hour > now.getHours() || hour === now.getHours();
    },
    allowedMinutes(minute) {
      if (this.selectedDate !== this.minDate || !this.selectedTime) {
        return true;
      }
      const [selectedHour] = this.selectedTime.split(':').map(Number);
      const now = new Date();
      now.setMinutes(now.getMinutes() + 2);
      if (selectedHour === now.getHours()) {
        return minute >= now.getMinutes();
      }
      return true;
    },
    openFlatpickr() {
      this.$refs.flatpickrRef.fp.open();
    },
  },
  data() {
    return {
      approveMasterIds: null,
      approveImportDialogShow: false,
      headingErrorsShow: false,
      headingErrors: '',
      valid: false,
      line_id: null,
      direction_id: null,
      snack_bar: {
        show: false,
        message: "",
        timeout: 4000,
        top: true,
        right: true,
        bottom: false,
        left: false,
        color: "",
      },
      headers: [
        {
          text: 'Line Name',
          value: 'line_name',
          sortable: false,
        },
        {
          text: 'Direction Name',
          value: 'direction_name',
          sortable: false,
        },
        {
          text: 'Status',
          value: 'status',
          sortable: false,
        },
        {
          text: 'Uploaded File',
          value: 'file_path',
          sortable: false,
        },
        {
          text: 'Error File',
          value: 'error_file_path',
          sortable: false,
        },
        {
          text: 'Last Updated At',
          value: 'updated_at',
          sortable: false,
        },
      ],
      import_masters: [],
      lines: [],
      directions: [],
      loading: {
        import_masters: false,
        submit: false,
        lines: false,
        directions: false,
      },
      total_items: 0,
      masterImportId: null,
      storeDialog: false,
      downloadDialog: false,
      downloadLine: '',
      downloadDirection: '',
      downloadHarbourRoute: '',
      harbourRoutes: [
        { id: 'PNVL_CSMT', name: '(PNVL - CSMT)' },
        { id: 'CSMT_GMN', name: '(CSMT - GMN)' },
        { id: 'PNVL_GMN', name: '(PNVL - GMN)' },
      ],
      addUpdateImportDialog: false,
      downloadCompleteTrainSchedule: false,
      completeScheduleDownloadLine: '',
      completeScheduleDownloadDirection: '',
      minDate: new Date().toISOString().split('T')[0],
      selectedDateTime: '',
      flatpickrConfig: {
        enableTime: true,
        noCalendar: false,
        dateFormat: 'Y-m-d H:i',
        time_24hr: true,
        minDate: 'today',
        minuteIncrement: 1,
        disableMobile: true,
        onReady: function(selectedDates, dateStr, instance) {
          instance.calendarContainer.style.marginTop = '5%';
          instance.calendarContainer.style.marginLeft = '30%';
        },
        onChange: (selectedDates, dateStr, instance) => {
          if (!selectedDates.length) return;

          const selected = selectedDates[0];
          const datePart = dateStr.split(' ')[0];
          const today = new Date();
          const isToday =
            selected.getFullYear() === today.getFullYear() &&
            selected.getMonth() === today.getMonth() &&
            selected.getDate() === today.getDate();

          if (isToday) {
            // Set minTime to now + 2 minutes
            const minTime = new Date();
            minTime.setMinutes(minTime.getMinutes() + 2);
            const hh = minTime.getHours().toString().padStart(2, '0');
            const mm = minTime.getMinutes().toString().padStart(2, '0');
            instance.set('minTime', `${hh}:${mm}`);

            // Allow changing time for today, but do not allow time before now + 2 minutes
            if (selected < minTime) {
              const clampedDate = new Date(selected);
              clampedDate.setHours(minTime.getHours(), minTime.getMinutes(), 0, 0);
              instance.setDate(clampedDate, false);
              this.selectedDateTime = `${datePart} ${hh}:${mm}`;
            } else {
              const selectedHour = selected.getHours().toString().padStart(2, '0');
              const selectedMinute = selected.getMinutes().toString().padStart(2, '0');
              this.selectedDateTime = `${datePart} ${selectedHour}:${selectedMinute}`;
            }
          } else {
            // Future date — remove minTime restriction, set 03:00
            instance.set('minTime', null);
            instance.setDate(`${datePart} 03:00`, false);
            this.selectedDateTime = `${datePart} 03:00`;
          }
        },
      },
    }
  }
}
</script>

<style scoped>

</style>
